import BaseService from '../base-service';
import StandardResponse from '../../models/standard-response';
import { ILookupDetailList, ILookupDetailRequest } from 'models/common-models';
import { IRegionData } from 'models/cpo-interface';
import { store } from 'store';
import axios from 'axios';
export default class CommonService {
    getLookupDetailList = async (data: ILookupDetailRequest): Promise<StandardResponse<ILookupDetailList[]>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/common/lookups`,
                method: 'POST',
                data,
            });
            return new StandardResponse<ILookupDetailList[]>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getConfiguration = async (data: any): Promise<any> => {
        try {
            const res = await BaseService({
                url: 'v1/admin/configuration/search',
                method: 'POST',
                data,
            });
            return Promise.resolve(res.data);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getConfigurationList = async (data: any): Promise<any> => {
        try {
            const res = await BaseService({
                url: '/v1/admin/configuration/list',
                method: 'POST',
                data,
            });
            return Promise.resolve(res.data);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getRegionList = async (): Promise<IRegionData> => {
        const headers = {
            language: store?.getState()?.UserData?.language?.code ? store?.getState()?.UserData?.language?.code : 'en',
            Authorization: process.env.REACT_APP_GLOBAL_SERVICE_API_TOKEN,
        };
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_GLOBAL_API_SERVER}/v1.0/global-services/regions/search`,
                {},
                {
                    headers: headers,
                },
            );
            return Promise.resolve(res.data);
        } catch (e) {
            return Promise.reject(e);
        }
    };
}
